const hardDeleteEquipmentServices = {
  toastr: 'Inspección eliminada'
};

export default hardDeleteEquipmentServices;
